import { createSelector } from '@reduxjs/toolkit';

import { StoreState } from '../types';

import { supportsAuthor } from './consts';
import { BookingsPageMode, BookingsPageRole, BookingsState } from './types';

export const getBookingsState = (state: StoreState): BookingsState =>
  state.bookings;

export const getBookingsFiltersCount = createSelector(
  getBookingsState,
  bookings =>
    +(!!bookings.from && !!bookings.to) +
    +(bookings.bookingObjectType
      ? supportsAuthor.has(bookings.bookingObjectType) &&
        bookings.role === BookingsPageRole.Author
      : 0),
);

export const getAreBookingsActual = createSelector(
  getBookingsState,
  bookings => bookings.mode === BookingsPageMode.Actual,
);

export const getIsAuthor = createSelector(
  getBookingsState,
  bookings => bookings.role === BookingsPageRole.Author,
);
